import nxModule from 'nxModule';
import config from '../react/config';

nxModule.constant('config', config);
